import React from "react";

export function ResultSummaryRow({ label, value, unit, disabled = false }) {
  return (
    <div className="result-summary-row">
      <div className="result-summary-row-label">{label}</div>
      <div
        className={[
          "result-summary-row-value",
          disabled ? "!text-greyscale-3" : "text-primary",
        ].join(" ")}
      >
        {value}
        {unit ? <span className="muted-text"> {unit}</span> : null}
      </div>
    </div>
  );
}

export function ResultSummarySection({
  icon,
  title,
  disabled = false,
  children,
}) {
  const iconClassName = [
    "result-summary-section-icon",
    disabled ? "fill-greyscale-3" : "text-tertiary fill-tertiary",
    icon?.props?.className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="result-summary-section">
      <div className="result-summary-section-header">
        {icon ? React.cloneElement(icon, { className: iconClassName }) : null}
        <div className="result-summary-section-title">{title}</div>
      </div>
      {children}
    </div>
  );
}
